// extracted by mini-css-extract-plugin
export default {"sportsmen_item":"styles_sportsmen_item__OqOIe","sportsmen_item_1":"styles_sportsmen_item_1__NNp3b","sportsmen_item_2":"styles_sportsmen_item_2__9XLjJ"};